/**
 * Pure controlled toggle between visual and raw editor modes
 * (TASK-181 WP-D CP-1).
 *
 * Pattern: the parent owns the mode state in useState so a parse-block
 * guard can intercept raw → visual transitions (see FormConfigSettings
 * for the actual wiring).
 *
 * `disabledReason` (TASK-181 review FIX 1): when supplied and the user is
 * currently in raw mode, the "Vizuální" button is disabled and a warning
 * line is rendered under the toggle. The parent (FormConfigSettings)
 * sets it when the raw textarea fails the parse guard, so the user can
 * see *why* the toggle is blocked without losing the broken raw text.
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@folio/stripes/components';
var ModeToggle = function (_a) {
    var mode = _a.mode, onChange = _a.onChange, disabledReason = _a.disabledReason;
    var isBlocked = !!disabledReason && mode === 'raw';
    return (React.createElement("div", { "data-testid": "mode-toggle-wrapper" },
        React.createElement("div", { style: { display: 'inline-flex', gap: '0.25rem' }, "data-testid": "mode-toggle" },
            React.createElement(Button, { buttonStyle: mode === 'visual' ? 'primary' : 'default', onClick: function () { return mode !== 'visual' && onChange('visual'); }, disabled: isBlocked, title: isBlocked ? disabledReason : undefined, "data-testid": "mode-toggle-visual", marginBottom0: true },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.settings.forms.visual.toggle.visual" })),
            React.createElement(Button, { buttonStyle: mode === 'raw' ? 'primary' : 'default', onClick: function () { return mode !== 'raw' && onChange('raw'); }, "data-testid": "mode-toggle-raw", marginBottom0: true },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.settings.forms.visual.toggle.raw" }))),
        isBlocked && (React.createElement("div", { "data-testid": "mode-toggle-block-warning", style: { marginTop: '0.25rem', color: '#c80', fontSize: '0.8rem' } },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.settings.forms.visual.toggle.parseBlockWarning" })))));
};
export default ModeToggle;
